// @material-ui/core components
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'
import Modal from '@material-ui/core/Modal'
import withStyles from '@material-ui/core/styles/withStyles'
// @material-ui/icons
import Add from '@material-ui/icons/Add'
import Remove from '@material-ui/icons/Remove'
import { postObjects } from 'api/api'
import Card from 'components/Card/Card.jsx'
import CardBody from 'components/Card/CardBody.jsx'
import CardFooter from 'components/Card/CardFooter.jsx'
import React from 'react'

const styles = {}

class ConfirmModalv2 extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      object: props.object,
    }
  }

  componentWillReceiveProps(props) {
    this.setState({
      object: props.object,
    })
  }

  callback = (response) => {
    this.setState({ srcImage: this.state.srcImage + response.data })
  }

  callbackError = (error) => {
    alert(error)
  }

  onDecreaseQuantity = (productId) => {
    const newProducts = this.state.object.products.map((product) => {
      return product.id === productId
        ? { ...product, pivot: { ...product.pivot, quantity: parseInt(product.pivot.quantity) - 1 } }
        : product
    })
    const newTotal = newProducts.reduce((acc, product) => acc + product.price * product.pivot.quantity, 0)
    this.setState({
      object: {
        ...this.state.object,
        products: newProducts,
        total: newTotal,
      },
    })
  }

  onIncreaseQuantity = (productId) => {
    const newProducts = this.state.object.products.map((product) => {
      return product.id === productId
        ? { ...product, pivot: { ...product.pivot, quantity: parseInt(product.pivot.quantity) + 1 } }
        : product
    })
    const newTotal = newProducts.reduce((acc, product) => acc + product.price * product.pivot.quantity, 0)
    this.setState({
      object: {
        ...this.state.object,
        products: newProducts,
        total: newTotal,
      },
    })
  }

  onHandleSave = () => {
    // Prepara i dati dei prodotti nel formato richiesto
    const productsData = {
      products: this.state.object.products.map((product) => ({
        id: product.id,
        quantity: parseInt(product.pivot.quantity),
      })),
    }

    // Salva i prodotti aggiornati senza confermare l'uscita
    postObjects(
      productsData,
      `registrations/${this.state.object.id}/products`,
      (response) => {
        this.props.handleClose()
      },
      (error) => {
        alert('Errore durante il salvataggio dei prodotti: ' + error)
      }
    )
  }

  onHandleConfirm = () => {
    // Prepara i dati dei prodotti nel formato richiesto
    const productsData = {
      products: this.state.object.products.map((product) => ({
        id: product.id,
        quantity: parseInt(product.pivot.quantity),
      })),
    }

    //se non ci sono prodotti processi subito all'handle confirm
    if (productsData.products.length === 0) {
      this.props.handleConfirm()
      return
    }

    // Prima salva i prodotti aggiornati
    postObjects(
      productsData,
      `registrations/${this.state.object.id}/products`,
      (response) => {
        // Dopo il successo, procedi con la conferma dell'uscita
        this.props.handleConfirm()
      },
      (error) => {
        alert('Errore durante il salvataggio dei prodotti: ' + error)
      }
    )
  }

  render() {
    const { object } = this.state
    var modalRender = null
    if (this.state.object !== null) {
      modalRender = (
        <div style={{ width: '100wv', height: '100wh' }}>
          <Modal
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            open={this.props.open}
            onClose={this.props.handleClose}
            style={{}}
          >
            <Card
              style={{
                position: 'absolute',
                marginTop: '0px',
                marginBottom: '0px',
                left: '50%',
                top: '50%',
                width: '700px',
                minHeight: object.products !== undefined && object.products.length > 0 ? '400px' : '100px',
                transform: 'translate(-50%, -50%)',
              }}
            >
              <CardBody>
                <div style={{ backgroundColor: 'white', textAlign: 'center' }}>
                  {this.props.message} {object.customer_2 !== '' && ' e ' + object.customer_2}
                  {object.extra !== '' && (
                    <div style={{ border: '1px solid lightgrey' }}>
                      <p>Gli extra sono : {object.extra}</p>
                    </div>
                  )}
                  {object.products !== undefined && object.products.length > 0 ? (
                    <div>
                      <div>
                        <p>I prodotti acquistati sono i seguenti</p>
                      </div>

                      <div
                        style={{
                          backgroundColor: 'white',
                          textAlign: 'center',
                          maxHeight: '250px',
                          overflowY: 'auto',
                        }}
                      >
                        <style>{`
     tr:nth-child(even) {
  background-color: #D6EEEE;
}
tr:nth-child(odd) {
  background-color: #FFFFFF;
}
  `}</style>
                        <table
                          style={{ height: '40px', width: '100%', border: '2px solid lightgrey', borderBottom: '1' }}
                        >
                          <tr
                            style={{
                              'border-bottom': '1px solid lightgrey',
                              //sticky top
                              position: 'sticky',
                              top: 0,
                              backgroundColor: 'white',
                            }}
                          >
                            <td align="left">Nome prodotto</td>
                            <td style={{ whiteSpace: 'nowrap', width: '64px' }}>Prezzo</td>
                            <td style={{ whiteSpace: 'nowrap', width: '64px' }}>Quantità</td>
                            <td style={{ whiteSpace: 'nowrap', width: '120px' }}>Azioni</td>
                          </tr>
                          {object.products &&
                            object.products.map((prop, key) => {
                              return (
                                <tr style={{ 'border-bottom': '1px solid red' }}>
                                  <td align="left">{prop.name}</td>
                                  <td style={{ whiteSpace: 'nowrap', width: '64px' }}>{prop.price} €</td>
                                  <td style={{ whiteSpace: 'nowrap', width: '64px' }}>
                                    {parseInt(prop.pivot.quantity)}
                                  </td>
                                  <td style={{ whiteSpace: 'nowrap', width: '120px' }}>
                                    <IconButton
                                      size="small"
                                      onClick={() => this.onDecreaseQuantity(prop.id)}
                                      disabled={parseInt(prop.pivot.quantity) < 1}
                                      style={{ marginRight: '4px' }}
                                    >
                                      <Remove fontSize="small" />
                                    </IconButton>
                                    <IconButton size="small" onClick={() => this.onIncreaseQuantity(prop.id)}>
                                      <Add fontSize="small" />
                                    </IconButton>
                                  </td>
                                </tr>
                              )
                            })}
                        </table>
                      </div>
                    </div>
                  ) : (
                    <div>Nessun prodotto acquistato</div>
                  )}
                  <div style={{ marginTop: '12px', fontWeight: 'bold', fontSize: '20px' }}>
                    Resoconto spese: {object.total} €
                  </div>
                </div>
              </CardBody>
              <CardFooter style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Button style={{ width: '30%' }} onClick={this.props.handleClose} variant="contained" color="white">
                  No
                </Button>

                <Button style={{ width: '30%' }} onClick={this.onHandleSave} variant="contained" color="success">
                  Salva
                </Button>

                <Button style={{ width: '30%' }} onClick={this.onHandleConfirm} variant="contained" color="primary">
                  Si
                </Button>
              </CardFooter>
            </Card>
          </Modal>
        </div>
      )
    }

    return modalRender
  }
}

export default withStyles(styles)(ConfirmModalv2)
